import { Text } from "@ucl/react-library";
import { Trans, useTranslation } from "react-i18next";
import { ContactDetailsEdit } from "src/components/contact-details/contact-details-edit";
import { ContactDetailsView } from "src/components/contact-details/contact-details-view";
import { translationMapping } from "src/utils/translation-mappings";

type ContactDetailsSectionProps = {
  showContactPreference?: boolean;
  showSubmitButton?: boolean;
  editShowError?: boolean;
  onCloseEditError?: () => void;
  showContactExplainer?: boolean;
  showEditDetails?: boolean;
  toggleContactDetails: () => void;
};

export const ContactDetailsSection = ({
  showContactPreference = false,
  showSubmitButton = false,
  editShowError = false,
  onCloseEditError,
  showContactExplainer = false,
  showEditDetails = false,
  toggleContactDetails,
}: ContactDetailsSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-5">
      {showSubmitButton ? (
        <div className="flex flex-col gap-5">
          <Text renderAs="h2" styleType="h3" fontWeight="semi-bold" data-testid="contactDetailsTitle">
            {t("contactDetails.title")}
          </Text>

          <Text.P size="large" >
            {t("contactDetails.updateAllInfo")}
          </Text.P>

          <Text.P size="large" data-testid="editContactDetailsUpdateNotice">
            <Trans i18nKey={"contactDetails.updateAllCasesNotice"} components={translationMapping(t)} />
          </Text.P>

          <Text
            renderAs="h3"
            styleType="h4"
            fontWeight="semi-bold"
            className="pt-5"
            data-testid="contactDetailsContactInfoHeading"
          >
            {t("contactDetails.contactInfo")}
          </Text>
        </div>
      ) : (
        <Text renderAs="h3" styleType="h4" fontWeight="semi-bold" data-testid="contactDetailsYourDetailsHeading">
          {t("contactDetails.yourDetails")}
        </Text>
      )}

      {showEditDetails ? (
        <ContactDetailsEdit
          showContactPreference={showContactPreference}
          showSubmitButton={showSubmitButton}
          toggleContactDetails={toggleContactDetails}
          showError={editShowError}
          onClose={onCloseEditError}
        />
      ) : (
        <ContactDetailsView toggleContactDetails={toggleContactDetails} showContactExplanation={showContactExplainer} />
      )}
    </div>
  );
};
